const env_settings = {
  production: {
    API_URL: "/a/api/v1",
    API_URL_NEW: "/api/v1",
    API_URL_V2: "/a/api/v2",
    API_URL_V3: "/a/api/v3",
    API_URL_V4: "/a/api/v4",
    APP_URL: "/a",
    DASHBOARD_URL: "/dashboard",
    INTERNAL_APP_URL: "/internal_v2",
    LOCALIZED_URL: "/:language",
    QUERY_BUILDER_API_URL: "http://localhost:8003",
  },
  development: {
    API_URL: "/a/api/v1",
    API_URL_NEW: "/api/v1",
    API_URL_V2: "/a/api/v2",
    API_URL_V3: "/a/api/v3",
    API_URL_V4: "/a/api/v4",
    APP_URL: "/a",
    DASHBOARD_URL: "/dashboard",
    INTERNAL_APP_URL: "/internal_v2",
    LOCALIZED_URL: "/:language",
    QUERY_BUILDER_API_URL: "http://localhost:8003",
  },
  test: {
    API_URL: "http://localhost:8000/a/api/v1",
    API_URL_NEW: "http://localhost:8000/api/v1",
    API_URL_V2: "http://localhost:8000/a/api/v2",
    API_URL_V3: "http://localhost:8000/a/api/v3",
    API_URL_V4: "http://localhost:8000/a/api/v4",
    APP_URL: "http://localhost:8000/a",
    DASHBOARD_URL: "http://localhost:8000/dashboard",
    INTERNAL_APP_URL: "/internal_v2",
    LOCALIZED_URL: "/:language",
    QUERY_BUILDER_API_URL: "http://localhost:8003",
  },
};
export const env = process.env.NODE_ENV as
  "production" | "development" | "test";

export const config = env_settings[env] || env_settings["production"];
